<mat-grid-list cols="2" rowHeight="40px" gutterSize="16px">
  <mat-grid-tile class="text-left">
    <div class="section-title flex-1 text-left">Location filters</div>
  </mat-grid-tile>
  <mat-grid-tile>
    <div class="actions text-right flex-1">
      <lib-button icon="add" color="primary" [matMenuTriggerFor]="addCampaignMenu">Add Location Filter</lib-button>
      <mat-menu #addCampaignMenu="matMenu">
        <button mat-menu-item (click)="onAddFilter_ByOrganizationId()">By Organization Id</button>
        <button mat-menu-item (click)="onAddFilter_ByOrganizationTag()">By Organization Tag</button>
      </mat-menu>
    </div>
  </mat-grid-tile>
</mat-grid-list>
@if (model?.filters.length > 0) {
<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" [selectedIndex]="currentView" >
  @for (filter of model?.filters; track filter; let ix = $index) {
    @if (filter.type === LocFilterType.ByOrganizationId) {
      <mat-tab label="Organisation locations">
        <app-filter-by-organization-id [model]="filter"
        (deleteOrganisationId)="onDeleteOrganisationId($event)" />
      </mat-tab>
    }
    @else {
      <mat-tab label="Organisations locations by tags">
        <app-filter-by-organization-tag [model]="filter" (delete)="onDeleteFilter($event)" />
      </mat-tab>
    }
  }
</mat-tab-group>
}


@if (model?.filters.length === 0) {
<div>No campaign location filters</div>
}